import React from "react";
import { Outlet, NavLink, useLocation } from "react-router-dom";
import RefreshButtonTable from "../../../common/RefreshButtonTable";
import "../../../../common/styles/table.css";

/**
 * ReportsLayout - Common layout for Reports & Analytics section
 * Provides header, tab navigation, and renders child routes via Outlet
 */
const ReportsLayout = () => {
    const location = useLocation();
    const isTeachersTab = location.pathname.includes("/teachers");

    return (
        <div>
            <div className="pb-4 fs-3 fw-semibold">Reports &amp; Analytics</div>
            <div>
                <div className="tabs-container">
                    <NavLink
                        to="/school-admin/school/report/teachers"
                        className={({ isActive }) =>
                            `tab-btn ${isActive || isTeachersTab ? "active" : ""}`
                        }
                    >
                        Teachers
                    </NavLink>
                    <NavLink
                        to="/school-admin/school/report/students"
                        className={({ isActive }) =>
                            `tab-btn ${isActive ? "active" : ""}`
                        }
                    >
                        Students
                    </NavLink>
                </div>
            </div>

            <Outlet />
        </div>
    );
};

export default ReportsLayout;
